import { createAction, createReducer } from '@reduxjs/toolkit';
import { fromStore } from '../../utils/localStorageStore';

// Recruiting-bonus dashboard (CREW-1034). Bespoke module (not the CRUD
// helper set) — the page holds several independent datasets rather than a
// single paginated list.
const P = '@RECRUITING_METRICS';

const make = (name) => createAction(`${P}/${name}`);

export const actions = {
  loadRecruitersRequest: make('LOAD_RECRUITERS_REQUEST'),
  setRecruiters: make('SET_RECRUITERS'),
  loadDashboardRequest: make('LOAD_DASHBOARD_REQUEST'),
  setSummary: make('SET_SUMMARY'),
  setCoordination: make('SET_COORDINATION'),
  setCoordinationCharts: make('SET_COORDINATION_CHARTS'),
  setResults: make('SET_RESULTS'),
  setPromotion: make('SET_PROMOTION'),
  setTasks: make('SET_TASKS'),
  setOverdue: make('SET_OVERDUE'),
  setSettings: make('SET_SETTINGS'),
  saveSettingsRequest: make('SAVE_SETTINGS_REQUEST'),
  loadBonusReportRequest: make('LOAD_BONUS_REPORT_REQUEST'),
  setBonusReport: make('SET_BONUS_REPORT'),
  loadBonusHistoryRequest: make('LOAD_BONUS_HISTORY_REQUEST'),
  setBonusHistory: make('SET_BONUS_HISTORY'),
  closeMonthRequest: make('CLOSE_MONTH_REQUEST'),
  setLoading: make('SET_LOADING'),
  setError: make('SET_ERROR'),
  setFilter: make('SET_FILTER'), // persisted via STORE_KEYS
};

export const RESULTS_FILTER = { ownerIds: [], managerIds: [], from: null, to: null };

export const initialState = {
  isLoading: false,
  error: null,
  recruiters: [],
  // true while `?function=` matched nobody (rollout: functions not assigned
  // yet) and the BE fell back to the unfiltered list — the tab shows a hint.
  recruitersFilterEmpty: false,
  currentClientId: null,
  // mode: null (not chosen yet → FE defaults to 'me' once) | 'me' | 'all' | 'selected'
  // month: optional 'YYYY-MM' — "compare to" a past settled period
  // tab: which bonus program the page shows (CREW-1157)
  // results: the Results tab's own filter — owners, fleet managers, period (CREW-1312)
  filter: fromStore('recruitingMetrics.filter', { mode: null, clientIds: [], month: null, tab: 'recruiting', results: RESULTS_FILTER }),
  summary: null,
  coordination: null,
  coordinationCharts: null,
  results: null,
  promotion: null,
  tasks: null,
  overdue: null,
  settings: null,
  bonusReport: null,
  bonusHistory: null,
};

export const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.setLoading, (state, { payload }) => { state.isLoading = payload; })
    .addCase(actions.setError, (state, { payload }) => { state.error = payload; state.isLoading = false; })
    .addCase(actions.setRecruiters, (state, { payload }) => {
      state.recruiters = payload?.recruiters || [];
      state.recruitersFilterEmpty = !!payload?.function_filter_empty;
      state.currentClientId = payload?.current_client_id || null;
    })
    .addCase(actions.setFilter, (state, { payload }) => { state.filter = payload; })
    .addCase(actions.setSummary, (state, { payload }) => { state.summary = payload; })
    .addCase(actions.setCoordination, (state, { payload }) => { state.coordination = payload; })
    .addCase(actions.setCoordinationCharts, (state, { payload }) => { state.coordinationCharts = payload; })
    .addCase(actions.setResults, (state, { payload }) => { state.results = payload; })
    .addCase(actions.setPromotion, (state, { payload }) => { state.promotion = payload; })
    .addCase(actions.setTasks, (state, { payload }) => { state.tasks = payload; })
    .addCase(actions.setOverdue, (state, { payload }) => { state.overdue = payload; })
    .addCase(actions.setSettings, (state, { payload }) => { state.settings = payload; })
    .addCase(actions.setBonusReport, (state, { payload }) => { state.bonusReport = payload; })
    .addCase(actions.setBonusHistory, (state, { payload }) => { state.bonusHistory = payload; });
});
